import { Api } from './Api';

export class User {
  static getUserInfo = <T>() => Api.get<T>('dashboard/account_info/');

  static updateUserInfo(body: any): ReturnType<typeof Api.patch> {
    return Api.patch('dashboard/account_info/', {
      clinic_name: body.clinic_name,
      email: body.email,
      full_name: body.full_name,
      position_title: body.position_title,
      phone_number: body.phone_number,
      country: body.country || '',
    });
  }
  static updateUserPassword(body: any): ReturnType<typeof Api.put> {
    return Api.put('dashboard/edit_password/', {
      old_password: body.old_password,
      new_password: body.new_password,
      confirm_password: body.password_confirm,
    });
  }

  // CREDIT CARD DETAIL
  static getCreditCardInfo = <T>() => Api.get<T>('dashboard/payment_method/');

  static createCreditCardInfo = <T>(paymentMethod: string): ReturnType<typeof Api.post> => {
    return Api.post<T>('dashboard/payment_method/', {
      payment_method: paymentMethod,
    });
  };

  static deleteCreditCardInfo = <T>(id: number): ReturnType<typeof Api.delete> => {
    return Api.delete<T>(`dashboard/payment_method/${id}`);
  };

  static getTotalClickCount = <T>() => Api.get<T>('click/');

  static getCountriesList = <T>() => Api.get<T>('countries/');
}
